var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"options_title_lyout"},[_c('div',{staticClass:"options_title_lyout_title"},[_vm._v("\r\n        "+_vm._s(_vm.title)+"\r\n    ")]),_vm._v(" "),_c('div',{staticClass:"defalut_boder_bottom_line"})])}
var staticRenderFns = []

export { render, staticRenderFns }